import React from 'react';
import InputMaskBase, { Props as BaseInputMaskProps } from 'react-input-mask';
import { Input, Props as InputProps } from './Input';

/** @types/react-input-mask types `children` as a render prop; v3 uses cloneElement on a single element. */
type InputMaskBaseElementChildProps = Omit<BaseInputMaskProps, 'children'> & {
  children?: React.ReactElement;
};

const InputMaskBaseCompat = InputMaskBase as React.ComponentType<InputMaskBaseElementChildProps>;

export type Props = Omit<BaseInputMaskProps, 'css' | 'children'> & Omit<InputProps, 'children'>;

export const InputMask = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    mask,
    maskPlaceholder,
    alwaysShowMask,
    beforeMaskedStateChange,
    // START https://github.com/sanniassin/react-input-mask#usage
    value,
    onChange,
    disabled,
    onFocus,
    onBlur,
    onMouseDown,
    readOnly,
    // END https://github.com/sanniassin/react-input-mask#usage
    ...rest
  } = props;

  return (
    <InputMaskBaseCompat
      mask={mask}
      maskPlaceholder={maskPlaceholder || null}
      alwaysShowMask={alwaysShowMask}
      beforeMaskedStateChange={beforeMaskedStateChange}
      value={value}
      onChange={onChange}
      disabled={disabled}
      onFocus={onFocus}
      onBlur={onBlur}
      onMouseDown={onMouseDown}
      readOnly={readOnly}
    >
      <Input ref={ref} {...rest} />
    </InputMaskBaseCompat>
  );
});
